import Paper from "@material-ui/core/Paper";
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { fetchJSON } from "helpers/axios";
import LoadingOverlay from "react-loading-overlay";
import { makeStyles } from "@material-ui/core/styles";
import "bootstrap/dist/css/bootstrap.min.css";
import OSCOHTLOGO from "assets/images/OSCOHT-LOGO.jpg";

const useStyles = makeStyles({
  watermarkContainer: {
    position: "relative",
    overflow: "visible",
    minHeight: "100%",
  },
  watermarkWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    zIndex: 1,
  },
  watermarkImage: {
    width: "400px",
    height: "400px",
    opacity: 0.08,
    transform: "rotate(-15deg)",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) rotate(-15deg)",
  },
  content: {
    position: "relative",
    zIndex: 2,
    padding: "40px",
    backgroundColor: "transparent",
  },
  letterContainer: {
    width: "90%",
    maxWidth: "25cm",
    minHeight: "35cm",
    margin: "20px auto",
    position: "relative",
    backgroundColor: "white",
    padding: "0",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    borderRadius: "8px",
    overflow: "hidden",
  },
  letterContent: {
    position: "relative",
    padding: "40px 50px",
    minHeight: "calc(35cm - 80px)",
  },
  header: {
    textAlign: "center",
    marginBottom: "40px",
    paddingBottom: "30px",
    borderBottom: "3px solid #1E90FF",
  },
  logo: {
    width: "90px",
    height: "90px",
    objectFit: "contain",
    margin: "0 auto 20px",
    display: "block",
  },
  institutionName: {
    margin: 0,
    fontFamily: "'Playfair Display', serif",
    fontSize: "28px",
    fontWeight: "800",
    color: "#043820",
    letterSpacing: "0.5px",
    lineHeight: "1.2",
  },
  institutionAddress: {
    margin: "8px 0 0 0",
    fontFamily: "'Open Sans', sans-serif",
    fontSize: "16px",
    color: "#2c3e50",
    fontWeight: "600",
    letterSpacing: "0.3px",
  },
  refSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "40px",
    padding: "30px 0",
    borderBottom: "2px solid #e8f4fd",
    // backgroundColor: "#1E90FF",
    borderRadius: "8px",
    padding: "25px",
  },
  refLeft: {
    flex: 1,
    fontSize: "14px",
    fontWeight: "500",
    color: "#34495e",
    lineHeight: "1.6",
    fontFamily: "'Open Sans', sans-serif",
  },
  refRight: {
    textAlign: "right",
    fontSize: "14px",
    color: "#2c3e50",
    fontFamily: "'Open Sans', sans-serif",
  },
  greeting: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#2c3e50",
    marginBottom: "30px",
    fontFamily: "'Open Sans', sans-serif",
  },
  letterTitle: {
    textAlign: "center",
    margin: "30px 0 40px",
    padding: "20px",
    backgroundColor: "#f8fafc",
    borderRadius: "8px",
    border: "2px solid #1E90FF",
  },
  letterTitleText: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1E90FF",
    margin: 0,
    fontFamily: "'Open Sans', sans-serif",
    letterSpacing: "0.5px",
  },
  letterBody: {
    fontSize: "16px",
    lineHeight: "1.8",
    color: "#2c3e50",
    fontFamily: "'Open Sans', sans-serif",
    textAlign: "justify",
    "& p": {
      marginBottom: "20px",
    },
    "& ul": {
      paddingLeft: "25px",
      marginBottom: "25px",
    },
    "& li": {
      marginBottom: "12px",
      lineHeight: "1.7",
    },
  },
  signature: {
    textAlign: "right",
    marginTop: "50px",
    marginBottom: "60px",
    minHeight: "40px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  signatureName: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#043820",
    marginBottom: "5px",
    fontFamily: "'Open Sans', sans-serif",
  },
  signatureTitle: {
    fontSize: "18px",
    color: "#043820",
    fontWeight: "600",
    fontFamily: "'Open Sans', sans-serif",
    marginBottom: "20px",
    letterSpacing: "0.5px",
  },
  footer: {
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
    backgroundColor: "#1E90FF",
    color: "white",
    padding: "20px 30px",
    textAlign: "center",
  },
  footerTitle: {
    fontSize: "14px",
    fontWeight: "700",
    marginBottom: "15px",
    color: "#ffffff",
    fontFamily: "'Open Sans', sans-serif",
    letterSpacing: "0.5px",
  },
  footerContent: {
    fontSize: "12px",
    lineHeight: "1.6",
    color: "#e8f4fd",
    fontFamily: "'Open Sans', sans-serif",
    "& span": {
      display: "inline-block",
      margin: "0 15px",
    },
  },
  borderDecoration: {
    position: "absolute",
    top: "20px",
    left: "20px",
    right: "20px",
    bottom: "140px",
    pointerEvents: "none",
    "& .border-left, & .border-right": {
      position: "absolute",
      top: 0,
      bottom: 0,
      width: "3px",
      background: "linear-gradient(to bottom, #1E90FF, #043820)",
    },
    "& .border-left": {
      left: 0,
    },
    "& .border-right": {
      right: 0,
    },
  },
});

const Letter = ({ authUser, settings, applicantData }) => {
  const classes = useStyles();
  const [letterAdm, setLetterAdm] = useState(null);
  const [letterAdmFeeRows, setLetterAdmFeeRows] = useState(null);
  const [loader, setLoader] = useState(false);
  const [watermarks, setWatermarks] = React.useState([]);
  const containerRef = useRef(null);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      const width = containerRef.current.offsetWidth;
      const height = containerRef.current.offsetHeight;
      const numX = Math.ceil(width / 300);
      const numY = Math.ceil(height / 300);
      const marks = [];
      for (let y = 0; y < numY; y++) {
        for (let x = 0; x < numX; x++) {
          marks.push({ id: `${x}-${y}` });
        }
      }
      setWatermarks(marks);
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { token, ApplicantID } = authUser;
        setLoader(true);
        const response = await fetchJSON(
          `api/ProvisionalAdmissionLetter00?applicantId=${ApplicantID}`,
          null,
          "GET",
          token
        );

        setLoader(false);
        setLetterAdm(response.Data.response);
        setLetterAdmFeeRows(response.Data.feeRows);
      } catch (error) {
        console.log(error);
        setLoader(false);
      }
    })();
  }, [authUser]);

  if (!isLargeScreen) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px 20px",
          backgroundColor: "#fff3cd",
          color: "#856404",
          fontFamily: "'Open Sans', sans-serif",
          fontSize: "16px",
          borderRadius: "8px",
          margin: "20px",
          border: "1px solid #ffeaa7",
        }}
      >
        <h3 style={{ marginBottom: "20px", color: "#856404" }}>
          Screen Size Notice
        </h3>
        <p>
          This admission letter is optimized for larger screens (768px and above).
          Please use a desktop, laptop, or tablet in landscape mode to view this content properly.
        </p>
      </div>
    );
  }

  return (
    <>
      <LoadingOverlay active={loader} spinner text="Loading your admission letter...">
        <Paper elevation={0} style={{ backgroundColor: "#f5f7fa", minHeight: "100vh" }}>
        <div id="content">
          <div className={classes.letterContainer} ref={containerRef}>

            {/* Border Decorations */}
            <div className={classes.borderDecoration}>
              <div className="border-left"></div>
              <div className="border-right"></div>
            </div>

          

            <div className={classes.letterContent}>
              {/* Header */}
              <div className={classes.header}>
                <img
                  src={OSCOHTLOGO}
                  alt="College Logo"
                  className={classes.logo}
                />
                <div className={classes.headerText}>
                  <h1 className={classes.institutionName}>
                    ONDO STATE COLLEGE OF HEALTH TECHNOLOGY
                  </h1>
                  <h2 className={classes.institutionAddress}>
                    ODA ROAD, P.M.B. 791, AKURE
                  </h2>
                </div>
              </div>

              {/* Reference Section */}
              <div className={classes.refSection}>
                <div className={classes.refLeft}>
                  <div><strong>Your REF:</strong> No.CHT/1069/</div>
                  <div style={{ marginTop: "10px" }}>
                    All Communications should be addressed<br />
                    to the Provost quoting:
                  </div>
                  <div><strong>Our Ref No:</strong> ................</div>
                  <div><strong>Email:</strong> info@chta.ng</div>
                </div>
                <div className={classes.refRight}>
                  <div style={{ marginBottom: "15px", fontSize: "16px", fontWeight: "600" }}>
                    {letterAdm?.Department} Department
                  </div>
                  <div>
                    <strong>Date:</strong>{" "}
                    {new Date().toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}
                  </div>
                </div>
              </div>

              {/* Letter Content */}
              <div className={classes.greeting}>
                Dear {letterAdm?.FullName || "Prospective Student"},
              </div>

              <div className={classes.letterTitle}>
                <h3 className={classes.letterTitleText}>
                  OFFER OF PROVISIONAL ADMISSION
                </h3>
              </div>

              <div className={classes.letterBody}>
                <p>
                 <strong>1.{"   "}</strong>I am pleased to inform you that you have been offered <strong>provisional admission</strong> into
                  the Ondo State College of Health Technology, Akure for the award of{" "} <strong>{letterAdm?.ModeType}</strong> in the{" "}
                  <strong>{letterAdm?.DepartmentName || "your chosen field"}</strong> for the{" "}
                  <strong>{letterAdm?.Session || "2024/2025"}</strong> Academic Session.
                </p>

                <p>
                  <strong>2.{"   "}</strong>This admission is <strong>provisional</strong> and subject to the fulfillment of the following conditions:
                </p>

                <ul>
                  <li>
                    <strong>Academic Requirements:</strong> Satisfying all academic conditions and requirements
                    to pursue the above-mentioned programme.
                  </li>
                  <li>
                    <strong>Medical Fitness:</strong> Medical fitness certificate from a government-approved hospital.
                  </li>
                  <li>
                    <strong>Fee Payment:</strong> Evidence of payment of all prescribed fees, including acceptance fee
                    which must be paid within <strong>seven (7) days</strong> of receipt of this offer for onward registration.
                  </li>
                </ul>

                <p>
                  <strong>3.{"   "}</strong> Failure to meet the above conditions within the stipulated
                  time will lead to withdrawal/forfeiture of this offer.
                </p>

                <p>
                  <strong>4.{"   "}</strong>The College reserves the right to change your programme if you do not meet the criteria
                  for admission into the program for which you have been provisionally admitted.
                </p>

                <p>
                 <strong>5.{"   "}</strong>Please note that resumption for the session has been scheduled for Monday, 22nd September, 2025 and all admitted students are expected to be on campus for orientation and registration.


                </p>

                <p style={{ fontSize: "17px", fontWeight: "600", color: "#043820", marginTop: "20px" }}>
                  Congratulations on your successful admission! We look forward to welcoming you to our
                  esteemed institution and wish you tremendous success in your academic endeavours.
                </p>
              </div>

              <div className={classes.signature}>
                <div className={classes.signatureName}>
                  Omotoso E. B.
                </div>
                <div className={classes.signatureTitle}>
                  Registrar
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className={classes.footer}>
              <div className={classes.footerTitle}>
                INSTITUTION CONTACT DETAILS
              </div>
              <div className={classes.footerContent}>
                <div style={{ marginBottom: "8px" }}>
                  <strong>Address:</strong> Ondo State College of Health Technology, Akure, Ondo State, Nigeria
                </div>
                <div>
                  <span><strong>Phone:</strong> 08067858122, 07032250348</span>
                  <span><strong>Website:</strong> www.chta.ng</span>
                  <span><strong>Email:</strong> info@chta.ng</span>
                </div>
              </div>
            </div>
          </div>
          </div>
        </Paper>
      </LoadingOverlay>
    </>
  );
};

const mapStateToProps = ({ auth }) => {
  const authUser = auth.applicantUser;
  const settings = auth;
  return { authUser, settings };
};

export default connect(mapStateToProps, {})(Letter);